// Cevio-Bildzeichen „Ablauf-Ring" (Design-System 17.07.2026): offener Ring = Prozess, Punkt = Auftrag,
// der ihn durchläuft; formt zugleich das „C". Standalone läuft der Ring im Akzent-Verlauf (Stops via CSS
// aus den --accent-Tokens → folgt Theme + Nutzer-Akzentfarbe); im Marken-Chip der Kopfleiste (.wf-brand)
// überschreibt styles.css auf currentColor, sonst wäre er Orange-auf-Orange unsichtbar.
import { useId } from 'react'

export function BrandMark({ size = 19 }: { size?: number }) {
  // Eindeutige Gradient-ID pro Instanz — mehrere Marken auf einer Seite dürfen sich nicht teilen/überschreiben.
  const gradientId = useId()
  return (
    <svg className="wf-mark" width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" />
          <stop offset="1" />
        </linearGradient>
      </defs>
      <path d="M78 27 A35 35 0 1 0 78 73" stroke={`url(#${gradientId})`} strokeWidth="14" strokeLinecap="round" fill="none" />
      <circle cx="72" cy="50" r="8" />
    </svg>
  )
}
